import { render, staticRenderFns } from "./newAppointmentModal.vue?vue&type=template&id=6024ca7a&"
import script from "./newAppointmentModal.vue?vue&type=script&lang=js&"
export * from "./newAppointmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports